export default __webpack_public_path__ + "static/media/Business_Terms_TMS.a7f9a2ac.pdf";